export default "__VITE_ASSET__CChj$mI0__"